
import "./style.scss";

import sideLogin from '../../assets/img/side-login.png';

const OnBoardingPainel = ({}) => {
  return (
    <div
      className="tw-flex tw-flex-col tw-w-full tw-max-md:tw-ml-0 tw-max-md:tw-w-full tw-h-screen tw-shadow-md tw-bg-no-repeat tw-bg-cover tw-bg-black"
      style={{
        backgroundImage: `url(${sideLogin})`,
        backgroundPositionX: 'center',
      }}
    >
      <div className="tw-flex tw-overflow-hidden tw-relative tw-flex-col tw-grow tw-justify-center">
        <div className="tw-flex tw-relative tw-justify-center tw-items-center tw-px-8 tw-py-10 tw-mix-blend-hard-light tw-max-md:tw-px-5 tw-max-md:tw-max-w-full">
          <div className="tw-flex tw-flex-col tw-items-center tw-mt-2  tw-max-w-full tw-w-[720px] tw-max-md:tw-my-10">

          </div>
        </div>
      </div>
    </div>
  );
};

export default OnBoardingPainel;
